// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  base_url: 'https://euro-clic-service.duka.digital',
  base_graphql: 'https://euro-clic-service.duka.digital/graphql',
  base_directory: 'euro-clic-register.duka.digital',
  client_id: 'ac84e8db-b7d7-4ec5-b132-ad87de79900e',
  tenant_id: 'b84ab454-e321-43fd-83d7-d032f076ebb2',
  bucketUrl: 'https://duka-hml.s3.sa-east-1.amazonaws.com/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
